<template>
  <div :class="formGroupClass">
    <slot name="before"/>
    <label for="form-pass-cause" class="control-label">{{ inputLabel }}</label>
    <input
        type="time"
        v-model="inputValue"
        class="form-control time-picker-input"
        :disabled="disabled"
    />
    <error-help-block :has-errors="hasInputErrors" :current-error="actualErrorMessage"/>
    <slot name="after"/>
  </div>
</template>

<script>
import applicationInputMixin from '../../../../mixins/applicationInputMixin'
import applicationFormMixin from '../../../../mixins/applicationFormMixin'
import passSectionMixin from '../../../../mixins/application-form/passSectionMixin'
import passInputMixin from '../../../../mixins/application-form/passInputMixin'

export default {
  name: 'TimeToInput',
  mixins: [
    applicationInputMixin,
    applicationFormMixin,
    passSectionMixin,
    passInputMixin
  ],

  props: {
    inputLabel: {
      default: 'Время окончания'
    }
  }
}
</script>
